import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'colorFromLevel',
  standalone: true
})
export class ColorFromLevelPipe implements PipeTransform {
  transform(value: string, selected?: boolean): string {
    if (value === 'All Clear') {
      value = 'resolved';
    }

    const colors: any = {
      critical: selected ? '#ff2a4b' : '#DB1D3A',
      warning: selected ? '#ff7935' : '#EF6723',
      info: selected ? '#979797' : '#5c5c5c',
      unack: '#6B6983',
      acknowledged: selected ? '#aca7e9' : '#5a5692',
      acknow: selected ? '#aca7e9' : '#5a5692',
      closed: 'black',
      clear: 'rgb(19, 157, 235)',
      new: selected ? '#40c34a' : '#31a93a',
      none: 'green',
      resolved: '#139deb'
    };

    return colors[value] ?? '#000000';
  }
}
